const solutionList = [
    {
        imgPo: "imgLeft",
        type: "内窥镜模组",
        name: "Camera module of minimally invasive endoscope",
        title: "Camera module of minimally invasive endoscope",
        img: "/static/img/module/MicroCamera.png",
        point: ["Customized output interface", "Bundled application", "Highly customizable"],
        desc:
            "Minimally invasive endoscope camera module, 0.7mm to 4mm in diameter, customized output interface, can be bundled and applied to the enterprise products that need visual medicine, application fields: Medical: lung surgery, urinary surgery; police: letter, package, door seam and special narrow place safety inspection; industry: Casting and parts processing, micropore, blind hole, capillary, military industry.",
        fc: [
            { img: "", name: "medical care" },
            { img: "", name: "for police use" },
            { img: "", name: "Industry" },
        ],
        btn: {
            show: true,
            text: "View details",
        },
        param: [
            { key: "external diameter", val: "730*730um(+/-40um)" },
            { key: "pixel", val: "2.4 um x 2.4 um" },
            { key: "sensor", val: "AMS NanEyeXS" },
            { key: "Wire diameter", val: "小于1mm" },
            { key: "Line length", val: "2m（0-2m" },
            { key: "Frame rate", val: "13-55fps" },
            { key: "visual angle", val: "120︒" },
            { key: "Depth of field", val: "3-50mm" },
            { key: "Scan mode", val: "progressive scanning" },
            { key: "working temperature", val: "-30︒C  to  85︒C" },
            { key: "Fill light", val: "No / LED * 2 (customizable optical fiber lighting)" },
            { key: "Video interface", val: "HDMI/USB/TFT-LCD(Optional)" },
        ],
    },
    {
        imgPo: "imgLeft",
        type: "USB3",
        name: "USB3.0 High pixel and high rate imaging module",
        title: "USB3.0 High pixel and high rate imaging module",
        img: "/static/img/product/dzps.jpg",
        point: ["Fixed focus &amp; zoom optional", "Custom ISP"],
        desc:
            "USB3.0 High pixel high-speed imaging module, standard USB output format, can be customized according to different product application fields, fixed focus &amp; zoom optional, used in education, video conference, industrial detection and other fields.",
        fc: [
            { img: "", name: "education" },
            { img: "", name: "Videoconferencing" },
            { img: "", name: "Industrial testing" },
        ],
        btn: {
            show: true,
            text: "View details",
        },
        param: [
            { key: "sensor", val: "6.3mm*5.7mm" },
            { key: "Lens size", val: "1/3.2" },
            { key: "pixel size", val: "1.1um*1.1um BSI" },
            { key: "Most effective pixel", val: "4208H*3120V  1300万" },
            { key: "Output format", val: "YUV，MJPEG" },
            {
                key: "visual angle",
                val:
                    "4096*3072(3.5fps),3840*2160(7.5fps),1920*1080(30fps)，1600*1200(30fps),1280*720(30fps),1024*768(30fps),800*600(30fps),640*480(30fps)",
            },
            { key: "Signal to noise ratio", val: "37dB" },
            { key: "dynamic range", val: "69dB" },
            { key: "Interface type", val: "USB3.0" },
            {
                key: "Support exemption agreement",
                val: "USB Video Class(UVC)",
            },
            { key: "3A control", val: "support" },
            { key: "Power supply mode", val: "USB BUS POWER" },
            { key: "Power supply mode", val: "DV5V" },
            { key: "Working current", val: "50mA〜200mA" },
            { key: "working temperature", val: "（0℃〜65℃）" },
            { key: "Storage temperature", val: "（-30℃〜85℃）" },
        ],
    },
    {
        imgPo: "imgLeft",
        type: "M300B",
        name: "USB embedded facial biometric acquisition module",
        title: "USB embedded facial biometric acquisition module",
        img: "/static/img/module/m300b.png",
        point: ["safe and convenient", "double living detection", "fast response"],
        desc:
            "USB embedded facial identity information acquisition module can achieve fast and accurate facial multi-dimensional biometric information acquisition. It adopts the auxiliary focusing technology of real-time feedback, with fast acquisition speed and convenient interaction; it has dual live detection function of iris and face, realizing ultra-high security; it provides professional SDK development kit, realizing integrated development and verification within 2 days. Product parameters",
        fc: [
            { img: "", name: "Security" },
            { img: "", name: "clearance" },
            { img: "", name: "park" },
        ],
        btn: {
            show: true,
            text: "View details",
        },
        param: [
            {
                key: "Collect information",
                val: "Iris, visible face, near infrared face, depth information",
            },
            { key: "Recognition distance", val: "Iris: 45 ~ 65cm / face: 30 ~ 100cm" },
            {
                key: "Registration time",
                val: "Face registration time < 1.5s; iris registration time < 2S;",
            },
            { key: "Identification time", val: "Face recognition < 0.8s; iris recognition < 1s" },
            { key: "Recognition error rate", val: "0.0001%" },
            { key: "Recognition rejection rate", val: "0.1%" },
            {
                key: "Iris near infrared light source",
                val:
                    "Active lighting, lighting in accordance with IEC 62471:2006 non injury standard",
            },
            {
                key: "Near infrared face infrared light source",
                val:
                    "Active lighting, lighting in accordance with IEC 62471:2006 non Injury Standard",
            },
            { key: "In vivo detection", val: "1. Support for silent live detection" },
            {
                key: "",
                val:
                    "2. Support printing / display screen / Beauty pupil / facial mask and other prosthesis detection",
            },
            { key: "", val: "3. Face and iris can be detected separately" },
            {
                key: "Optional components",
                val:
                    "It can be equipped with rotating components, which can adapt to the height range of > 50cm.",
            },
            {
                key: "Use environment",
                val: "Indoor environment / semi outdoor (non direct sunlight)",
            },
            {
                key: "Interface",
                val: "Usb-3.0 (compatible with usb-2.0); zh1.5-2y power interface",
            },
            { key: "working temperature", val: "-10℃~55℃" },
            { key: "Working humidity", val: "0% ~ 90% RH, no fogging" },
            { key: "Development platform", val: "Support Android, windows and Linux" },
            { key: "Product size", val: "139 * 38 * 35mm (w * h * t)" },
            { key: "weight", val: "150g" },
            { key: "power", val: "<7w" },
        ],
    },
    {
        imgPo: "imgLeft",
        type: "S300-KQ",
        name: "Iris-Face Recognition Module",
        title: "Iris-Face Recognition Module",
        img: "/static/img/product/6.png",
        point: ["Flexible Networking", "Strong Expansibility", "Highly Customizable"],
        desc:
            "S300-KQ Iris and face recognition integrated module can efficiently and safely complete the registration and verification of iris face information. S300-KQ is easy to use due to autofocus, auto capturing user iris.S300-KQ has 1: N accurate identification mode, complete database function, and fully supports data management and backup.S300-KQ has world-class bioassay test technology and refuses any counterfeiting.",
        fc: [
            { img: "", name: "便于二次开发" },
            { img: "", name: "扩展性强" },
        ],
        btn: {
            show: true,
            text: "Detail",
        },
        param: [
            { key: "Product Model", val: "S300-KQ" },
            { key: "Product Size", val: "160mm*36mm*43mm" },
            { key: "Identify Distance Range", val: "45c~65cm" },
            {
                key: "Identify Height Range",
                val: "Support height adjustment by users themselves",
            },
            { key: "Registration Time", val: "<3s" },
            { key: "Recognition Time", val: "<1s" },
            { key: "Recognition Accuracy", val: "FAR:<0.00001%,FRR:<0.1%;" },
            // {key: '识别拒识率', val: '0.1%'},
            {
                key: "Iris Image",
                val: "Iris image complies with IS029794-6 and ISO19794-6",
            },
            {
                key: "Face Image",
                val: "Face image complies with IS029794-5 and ISO19794-5",
            },
            {
                key: "NIR Light Source",
                val: "LED light source complies with IEC-62471:2006",
            },
            { key: "Operation Temperature", val: "-10℃~55℃" },
            { key: "Operation Humidity", val: "0-90% RH，No condensation" },
        ],
    },
];

export default solutionList;
